import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGetUserInformation } from "../../../features/users";

import { useGetNotification } from "../../../lib/queries/queriesAndMutations";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import NotifCard from "./NotifCard";

const NotifPage = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const { data: user } = useGetUserInformation();
  const userId = user?.id;

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const {
    data: gatewayList,
    isPending,
    refetch,
    isRefetching,
  } = useGetNotification({
    userId,
    currentPage,
    pageSize,
  });

  const handleNewAccount = useCallback(() => navigate("/gateway/new"), [navigate]);

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {gatewayList?.data.count > 0 ? (
        <div className="w-full ">
          <div className="w-full flex flex-col items-end  p-2 rounded-v-lg gap-1 z-0 ">
            {gatewayList?.data.items.map((item, index) => (
              <NotifCard item={item} />
            ))}
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={gatewayList?.data?.count || 0}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
          <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
            <img src="/images/folder-empty.svg" alt="" className="max-w-[40px] max-h-[40px]" />
            <p> پیامی وجود ندارد!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default NotifPage;
